import styled from 'styled-components';

export const OverlayWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${({ theme }) => theme.zindex.navigation.overlay};
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
  backdrop-filter: blur(1px);
`;
